/*
  Resource portal experiene edit tab system
  1. Navigation to edit steps:
    About
    Details
    Photos
  2. Shows step completion status: progress
    Status indicators hidden when all steps complete

*/

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  selectStep,
  toggleMobileMenu,
} from 'data_system/resource_portal/actions/experienceActions';

import {
  getExperience,
  getLinkColor,
  getLocation,
  getMobileTabsMenuToggled,
  getSteps,
  getAboutCompleted,
  getDetailsCompleted,
  getPhotosCompleted,
  getAllStepsCompleted,
} from 'data_system/resource_portal/selectors';

import { t } from 'services/translation';

import CheckmarkIcon from 'views/ui/icons/checkmark-icon';

import {
  TabList,
  Tab,
  TabTitle,
  TabSubtitle,
  TabStatus,
  TabInfo,
  NavIcon,
} from './TabStyles';

const Tabs = () => {
  const dispatch = useDispatch();
  // const [showAdvancedTabs, setShowAdvancedTabs] = useState(false);

  const experience = useSelector(getExperience);
  const location = useSelector(getLocation);
  const steps = useSelector(getSteps);
  const mobileTabsMenuToggled = useSelector(getMobileTabsMenuToggled);
  const linkColor = useSelector(getLinkColor);

  const aboutCompleted = useSelector(getAboutCompleted);
  const detailsCompleted = useSelector(getDetailsCompleted);
  const photosCompleted = useSelector(getPhotosCompleted);
  const allStepsCompleted = useSelector(getAllStepsCompleted);

  // Check if selected
  const tabIsSelected = (step) => {
    const splitPath = location.pathname.split('/');
    const selectedStep = splitPath[splitPath.length - 1];
    return selectedStep === step.slug;
  };

  // Check if complete
  const tabIsCompleted = (step) => {
    switch (step.slug) {
      case 'about':
        return aboutCompleted;
      case 'details':
        return detailsCompleted;
      case 'photos':
        return photosCompleted;
      default:
        return false;
    }
  };

  // const toggleShowAdvancedTabs = setShowAdvancedTabs(!showAdvancedTabs);

  // Tab clicked
  const handleTabClicked = (step) => {
    dispatch(selectStep(step.slug));

    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  // For mobile - tabs responsively shift to a drop down (show/hide toggle)
  const handleMobileToggle = () => {
    dispatch(toggleMobileMenu());
  };

  // Current tab is advanced
  // const isAdvancedTab = step => step.title === 'Advanced Settings';

  // Render status indicator
  const renderStatus = (step) => {
    if (!allStepsCompleted) {
      return (
        <TabStatus color={linkColor} completed={tabIsCompleted(step)}>
          {tabIsCompleted(step) && <CheckmarkIcon />}
        </TabStatus>
      );
    }
    return <div />;
  };

  const renderTab = (step) => {
    if (!experience) return null;
    const { customLocationsEnabled } = experience;

    let { description } = step;
    if (customLocationsEnabled && step.slug === 'scheduling') {
      description = 'Capacity, Location, Schedule';
    }

    return (
      <span
        key={step.title}
        to={`/experiences/${experience.id}/edit/${step.slug}`}
      >
        <Tab
          gridTemplateColumns={allStepsCompleted ? '1fr' : '49px 1fr'}
          key={step.title}
          onClick={() => handleTabClicked(step)}
          selected={tabIsSelected(step)}
        >
          {renderStatus(step)}
          <TabInfo>
            <TabTitle>{t(step.title)}</TabTitle>
            <TabSubtitle>{t(description)}</TabSubtitle>
            <NavIcon />
          </TabInfo>
        </Tab>
      </span>
    );
  };

  return (
    <TabList mobileTabsMenuToggled={mobileTabsMenuToggled}>
      {steps.map((step) => renderTab(step))}
    </TabList>
  );
};

export default Tabs;
